<template>
  <transition name="el-fade-in-linear">
    <div>
      <!------------------------search---------------------->
      <el-form :inline="true" class="backborder1 demo-form-inline" ref="query" :model="query" size="small">
        <el-form-item style="width:15%">
          <el-input placeholder="请输入关键字" v-model="query.key" @keyup.enter.native="getList" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-plus" @click="addCombination">新增组合</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-plus" :disabled="this.selectedRows.length < 1" @click="showIsOnShelf = true">批量上下架组合</el-button>
        </el-form-item>
      </el-form>
      <!------------------------search end---------------------->

      <!------------------------组合套餐列表----------------------->
      <div class="backborder2" style="margin-top:10px">
        <el-table :data="lists" v-loading="listLoading" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column label="ID" prop="id" width="90">
          </el-table-column>
          <el-table-column label="组合名称" prop="name"></el-table-column>
          <el-table-column label="组合价格" prop="price"></el-table-column>
          <el-table-column label="销量">
            <template slot-scope="scope">
              <div>{{ +scope.row.virtual_sales + +scope.row.real_sales }}</div>
              <div>(虚{{ scope.row.virtual_sales }} 真{{ scope.row.real_sales }})</div>
            </template>
          </el-table-column>
          <el-table-column label="限购" prop="limit_num">
            <template slot-scope="scope">
              <span v-if="scope.row.limit_type != '0'">{{ `按${scope.row.limit_type == 1 ? '每人' : '每店'}限购数量${scope.row.limit_num}` }}</span>
              <span v-else>不限购</span>
            </template>
          </el-table-column>
          <el-table-column label="商品信息">
            <template slot-scope="scope">
              <span>{{ scope.row.goods_num }}件商品</span>
              <el-button type="text" @click="showDetail(scope.row)">商品明细</el-button>
            </template>
          </el-table-column>
          <el-table-column label="上架">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.status" active-value="1"
                inactive-value="0" active-color="#13ce66" inactive-color="#cccccc" @change="handleStatusChange(scope.row)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" prop="create_time"></el-table-column>
          <el-table-column label="操作" width="210" align="center">
            <template slot-scope="scope">
              <el-button type="warning" size="small" round @click="editCurrent(scope.row)">编辑</el-button>
              <el-button type="" size="small" round @click="delCurrent(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" style="display: flex;justify-content: flex-end;">
          <!--分页begin-->
          <el-pagination @size-change="pageSizeChange" @current-change="pageCurrentChange" :current-page="query.p"
            :page-sizes="[10, 20, 50]" :page-size="query.rollpage" layout="total, sizes, prev, pager, next, jumper"
            :total="total_rows">
          </el-pagination>
          <!--分页end-->
        </div>
      </div>

      <!-- 批量上下架 -->
      <el-dialog title="批量上下架组合" :visible="showIsOnShelf" width="400px" @close="showIsOnShelf = false">
        <el-select v-model="isOnShelfCheckbox" placeholder="请选择" style="width: 100%;">
          <el-option label="上架" value="1"></el-option>
          <el-option label="下架" value="2"></el-option>
        </el-select>
        <template slot="footer">
          <el-button type="primary" @click="batchUpdateStatus">确定</el-button>
          <el-button @click="showIsOnShelf = false">取消</el-button>
        </template>
      </el-dialog>

      <!-- SKU弹窗 -->
      <CombinationDetail ref="detailRef" />
    </div>
  </transition>
</template>

<script>
import CombinationDetail from './CombinationDetail.vue'

export default {
  components: { CombinationDetail },
  data() {
    return {
      url: this.GLOBAL.domain + "Combination/index",
      showIsOnShelf: false,
      isOnShelfCheckbox: '',
      selectedRows: [],

      actionauth: '', //功能权限
      lists: [],
      total_rows: 0,
      listLoading: false,
      query: {
        act: 'lists',
        key: '',
        rollpage: 10, // 页大小
        p: 1
      },
    }
  },

  mounted() {
    this.getactionauth();
    this.getList();
  },

  methods: {
    showDetail(row) {
      this.$refs.detailRef.getList(row);
    },
    // 套餐批量上下架
    isOnShelf(ids, status) {
      this.$axios({
        url: this.GLOBAL.domain + 'Combination/index',
        method: 'post',
        data: {
          act: 'update_combination_status',
          id: ids,
          status: status
        }
      })
        .finally(() => {
          this.getList();
        });
    },
    handleStatusChange(row) {
      this.isOnShelf(row.id, row.status)
    },
    batchUpdateStatus() {
      
      const ids = this.selectedRows.map(row => row.id);
      const status = this.isOnShelfCheckbox === '1' ? '1' : '0';
      this.isOnShelf(ids.join(','), status);
      this.showIsOnShelf = false;
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },

    /** 重置表单 **/
    reset() {
      this.$refs.create.resetFields();
    },

    /** 获取功能权限 **/
    getactionauth() {
      var data = this.$cookies.get('actionauth');
      data = JSON.parse(data);
      this.actionauth = data;
    },

    /** 信息列表 **/
    getList() {
      this.listLoading = true;
      this.$axios({
        url: this.url,
        method: 'GET',
        params: this.query
      })
        .then(res => {
          console.log(res, 'RRRRRRRRRRRRRRRRRRR')
          this.lists = res.Data
          this.total_rows = +res.count || 0
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    pageSizeChange(val) {
      this.query.rollpage = val;
      this.getList();
    },
    pageCurrentChange(val) {
      this.query.p = val;
      this.getList();
    },

    /** 新增组合 **/
    addCombination() {
      this.$emit('listenchild', { name: '新增商品组合', url: 'CombinationEdit', data: {} });
    },
    // 删除组合
    delCurrent(row) {
      this.$confirm('此操作将永久删除该组合, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$axios({
            url: this.GLOBAL.domain + 'Combination/index',
            method: 'post',
            data: {
              act: 'del_combination',
              id: row.id
            }
          })
            .then(res => {
              // 删除成功
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              
            })
            .finally(() => {
              this.getList();
            });
        })
    },
    // 编辑组合
    editCurrent(row) {
      this.$emit('listenchild', { name: '编辑商品组合', url: 'CombinationEdit', data: row });
    },
  }
}
</script>
<style>
.backborder1 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 1% 1% 0 1%
}

.backborder2 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 0 1% 3% 1%
}
</style>


// WEBPACK FOOTER //
// src/components/mall/Combination.vue